import { Module } from '@nu-art/ts-common';
import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
import { AdvisorConfigKeyFE_SmartDocs_NoteIds, ModuleFE_RuntimeSmartNote } from '@app/advisor-frontend';
import { DispositionRecommendedAction } from '@app/advisor-shared';
import { PanelKey_Home, PanelKey_SmartDocs } from '@app/advisor-v5-shared';
import { ModuleFE_AdvisorMini } from './ModuleFE_AdvisorMini.js';
import { Board_SmartDocs } from '../_enum.js';
import { fetchDispositionNote } from '../_utils/fetch-disposition-note.js';
export const dispatch_OnLiveMDMChanged = new ThunderDispatcher('__onLiveMDMChanged');
export const LiveMDMOverlay = {
    disposition: 'disposition',
    sent: 'sent',
};
class ModuleFE_LiveMDM_Class extends Module {
    stamped;
    overlay;
    __onAdvisorReset = () => {
        this.stamped = undefined;
        this.overlay = undefined;
    };
    //######################### Public Logic #########################
    getNote = () => this.stamped?.note ?? this.getLatestMdmNote();
    getDispositionType = () => this.stamped?.dispositionType;
    getWorkingDiagnosis = () => this.stamped?.workingDiagnosis;
    getOverlay = () => this.overlay;
    isPanelOpen = () => {
        if (ModuleFE_AdvisorMini.getIsMiniActive())
            return ModuleFE_AdvisorMini.getCurrentFocusedPanel() === PanelKey_SmartDocs;
        return Board_SmartDocs.isOpen();
    };
    setStampedNote = (note, dispositionType, workingDiagnosis) => {
        this.stamped = { note, dispositionType, workingDiagnosis };
        this.overlay = undefined;
        dispatch_OnLiveMDMChanged.dispatchUI();
    };
    clearStampedNote = () => {
        this.stamped = undefined;
        dispatch_OnLiveMDMChanged.dispatchUI();
    };
    openOverlay = (overlay) => {
        this.overlay = overlay;
        dispatch_OnLiveMDMChanged.dispatchUI();
    };
    markNoteSent = () => {
        this.overlay = LiveMDMOverlay.sent;
        dispatch_OnLiveMDMChanged.dispatchUI();
    };
    closeOverlay = () => {
        if (!this.overlay)
            return;
        this.overlay = undefined;
        dispatch_OnLiveMDMChanged.dispatchUI();
    };
    closePanel = () => {
        if (ModuleFE_AdvisorMini.getIsMiniActive())
            ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
        else
            Board_SmartDocs.close();
    };
    showDispositionNote = async (dispositionType, openMethod, workingDiagnosis) => {
        const type = this.toDispositionType(dispositionType);
        if (!type)
            return;
        const note = await fetchDispositionNote(dispositionType, openMethod, workingDiagnosis);
        if (!note)
            return;
        this.setStampedNote(note, type, workingDiagnosis && {
            id: workingDiagnosis.pathway._id,
            label: workingDiagnosis.getLabel(),
        });
        this.openPanel();
    };
    //######################### Internal Logic #########################
    getLatestMdmNote = () => ModuleFE_RuntimeSmartNote.getLatestNote(AdvisorConfigKeyFE_SmartDocs_NoteIds.get()?.mdm);
    toDispositionType = (dispositionType) => {
        if (dispositionType === DispositionRecommendedAction.ADMIT)
            return 'admit';
        if (dispositionType === DispositionRecommendedAction.DISCHARGE)
            return 'discharge';
    };
    openPanel = () => {
        if (ModuleFE_AdvisorMini.getIsMiniActive())
            ModuleFE_AdvisorMini.openPanel(PanelKey_SmartDocs);
        else
            Board_SmartDocs.open();
    };
}
export const ModuleFE_LiveMDM = new ModuleFE_LiveMDM_Class();
//# sourceMappingURL=ModuleFE_LiveMDM.js.map